import React, { useState, useEffect } from "react";
import plots from "../assets/layout.png";
import plotverticle from '../assets/layoutverticle.png';
import layout3 from '../assets/layout/Mahalakshmi_golden_City_Layout.png';
import layout4 from '../assets/layout/Subham_Avenues_Layout.png';

const Plots = () => {
  const [isVisible, setIsVisible] = useState(false);
  // activeTab will now track the INDEX (0, 1, or 2)
  const [activeTab, setActiveTab] = useState(0);

  const layoutData = [
    { title: "Vajram", src: plots },
    { title: "Mahalakshmi's Golden City", src: layout3 },
    { title: "Subham Avenues", src: layout4 },
  ];

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="mb-[10%] md:mb-[5%] px-4" id="plots">
      <div className="m-5">
        <h2 className="text-center text-4xl font-bold text-gray-800">Layout Plans</h2>
        <p className="text-center text-gray-500 mt-2">Select a project to view details</p>
      </div>

      {/* Tab Navigation */}
      <div className="flex flex-wrap justify-center gap-2 mb-8">
        {layoutData.map((layout, index) => (
          <button
            key={index}
            // Pass the INDEX here instead of a manual ID
            onClick={() => setActiveTab(index)}
            className={`px-6 py-2 rounded-full transition-all duration-300 font-medium border ${activeTab === index
              ? "bg-blue-600 text-white border-blue-600 shadow-lg scale-105"
              : "bg-white text-gray-600 border-gray-200 hover:border-blue-400"
              }`}
          >
            {layout.title}
          </button>
        ))}
      </div>

      {/* Image Display Area */}
      <div className={`w-full md:w-[85%] lg:w-[75%] mx-auto transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
        }`}>
        <div className="relative overflow-hidden bg-gray-100 rounded-xl shadow-2xl border border-gray-100">
          {/* Safeguard with optional chaining: layoutData[activeTab]?.src */}
          <img
            key={activeTab}
            src={layoutData[activeTab]?.src}
            alt={layoutData[activeTab]?.title}
            className="w-full h-auto object-contain transition-transform duration-500 hover:scale-[1.02]"
          />
        </div>
      </div>
    </div>
  );
};

export default Plots;